import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {


  transform(value: string): string {
    const phoneStr = value.toString().replace(/\D/g, '');

    if (phoneStr.length !== 10) {
      return value.toString(); // Return original if not 10 digits
    }

    const areaCode = phoneStr.slice(0, 3);
    const centralOffice = phoneStr.slice(3, 6);
    const lineNumber = phoneStr.slice(6);

    return `(${areaCode}) ${centralOffice}-${lineNumber}`;
  }


}
